import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { deleteBranches, postActiveBranches } from "../../../../../MyApi/sb/branches";

import icons from "../../../../../Data/icons";
import classes from "../../../../../assets/css/dropdown.module.css";

const SingleBranch = ({ branch, refetch }) => {
  const { id, name, company, employe ,active} = branch;
  const [showDrop, setShowDrop] = useState(false);
  const [activeState,setActive]=useState(active)
  const navigate = useNavigate();

  const EditPen = icons.pen;

  const mutation = useMutation(
    ["deleteBranches", id],
    () => deleteBranches(id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        refetch();
    
      },
      onError: (error) => {
        toast.error(`${error.data.response.message}`);
      },
    }
  );




  const mutationActive = useMutation(
    ["postActive", id],
    (postData) => postActiveBranches(postData, id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        refetch();
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );
  
  const handelChangeActive = (e) => {
    const isChecked = e.target.checked;
    const newActiveState = isChecked ? 1 : 0;
  
    setActive(newActiveState);
    mutationActive.mutate({
      active: newActiveState,
    });
  }


  const deletePost = () => {
    mutation.mutate();
  };
  return (
    <tr>
      <td>
        <b>
          {name} #{id}
        </b>{" "}
        <br></br> {company}
      </td>
      <td>   
      <div>
            <label class="switch">
              <input
                type="checkbox"
                onChange={handelChangeActive}
                checked={activeState}
              />
              <span class="slider round"></span>
            </label>
          </div>
      </td>
      <td>
        <div>
          <button
            onClick={() => {
              setShowDrop(!showDrop);
            }}
            className="btn btn-primary dropdown-toggle"
            type="button"></button>
          {showDrop && (
            <ul className={classes.dropDownMenu}>
              <li>
                <Link
                  class="dropdown-item"
                  to={`${process.env.PUBLIC_URL}/branches/${id}`}>
                  <i class="fa fa-eye"></i>
                  عرض
                </Link>
              </li>
              <li>
                <Link
                  class="dropdown-item"
                  to={`${process.env.PUBLIC_URL}/branchesupdate/${id}`}>
                  <EditPen />
                  تعديل
                </Link>
              </li>
              <li>
                <button class="dropdown-item" onClick={deletePost}>
                  <i class="fa fa-trash"></i>
                  حذف
                </button>
              </li>
            </ul>
          )}
        </div>
      </td>
    </tr>
  );
};

export default SingleBranch;
